import React from 'react';
import classNames from 'classnames';

import css from './IconChecklist.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconChecklist = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#D2EFDF"/>
        <path d="M7.64155 12.4584C7.26602 12.0297 6.65718 12.0297 6.28165 12.4584C5.90612 12.8872 5.90612 13.5824 6.28165 14.0112L9.49344 17.6785C9.67423 17.8849 9.91896 18 10.1734 18C10.1912 18 10.2088 17.9993 10.2267 17.9982C10.4999 17.981 10.7535 17.8316 10.9244 17.5876L17.7894 7.78377C18.121 7.31007 18.0537 6.61931 17.6389 6.24052C17.224 5.86173 16.619 5.93873 16.2873 6.41243L10.0936 15.258L7.64155 12.4584Z" fill="url(#paint0_linear_278_3247)"/>
      <defs>
        <linearGradient id="paint0_linear_278_3247" x1="12.0071" y1="25.75" x2="12.0071" y2="6" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7FDCA4"/>
        <stop offset="1" stopColor="#47AD4B"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconChecklist;
